export default {
    hasClasses(state) {
        return state.classLists.length > 0;
    },
    getClassList(state) {
        return state?.v2?.teacher?.classList || [];
    },
};
